export const loginData = {
  id: 'admin',
  pw: 'admin',
};
